import { tagBodyReadFailure } from './network-failure.js';

// The proxy's endpoints answer their own rejections (401 "invalid token", 400 "Invalid coupon
// code") with a JSON { statusCode, message } body the page shows as-is, so the body is read
// whatever the status. A failure in front of them — the proxy's 502, Cloudflare's 520 — serves an
// HTML page instead, and parsing that raised a critical SyntaxError that hid the status (Rollbar
// #715, #498, #1984). Name the call and the status instead. A 2xx that is not JSON stays a parse
// failure: that one is a real fault.
//
// Matched by name: Safari's Response.json() rejects with a DOMException named SyntaxError ("The
// string did not match the expected pattern."), not a SyntaxError instance (Rollbar #2584).
export const readJsonOrStatus = (call) => (response) =>
    response.json().catch((err) => {
        if (!response.ok && err?.name === 'SyntaxError') {
            const statusError = new Error(`${call} failed: ${response.status}`);
            statusError.status = response.status;
            throw statusError;
        }
        return tagBodyReadFailure(err);
    });
